import LanguageIcon from '@mui/icons-material/Language'
import {
  KNCarriersIcon,
  KNCompaniesIcon,
  KNCompanyIcon,
  KNDriverIcon,
  KNHelpAndInfoIcon,
  KNInvoiceIcon,
  KNShipmentDescriptionIcon,
  KNTripIcon,
  KNUserIcon,
  KNUsersIcon,
  KNVehicleIcon,
} from 'components/KNIcon/KNIcon'
import { KNUnitsIcon } from 'components/KNIcon/KNMaterialIcon'
import { CompanyType } from 'context/authentication/Company.types'
import { Role } from 'context/authentication/Role.types'
import { hasAccess, isCompanyType } from 'global/helpers/authorization'

interface Section {
  sectionName: string
  sectionShortName?: string
  shortName?: string
  sectionOptions: SectionOption[]
  predicate?: () => boolean
}

export interface SectionOption {
  name: string
  label: string
  link: string
  icon: JSX.Element
  predicate?: () => boolean
}

export const menuOptions = (): Section[] => [
  {
    sectionName: 'drawer_menu.menu',
    sectionShortName: 'drawer_menu.menu',
    predicate: () => isCompanyType(CompanyType.Carrier),
    sectionOptions: [
      {
        name: 'trips',
        label: 'drawer_menu.trips',
        link: '/trips',
        icon: <KNTripIcon />,
      },
      {
        name: 'drivers',
        label: 'drawer_menu.drivers',
        link: '/drivers',
        icon: <KNDriverIcon />,
      },
      {
        name: 'vehicles',
        label: 'drawer_menu.vehicles',
        link: '/vehicles',
        icon: <KNVehicleIcon />,
      },
      {
        name: 'quotes',
        label: 'drawer_menu.quotes',
        link: '/quotes',
        icon: <KNCarriersIcon />,
      },
      {
        name: 'carrier-profile',
        label: 'drawer_menu.profile',
        link: '/carrier-profile',
        icon: <KNCompanyIcon />,
        predicate: () => hasAccess(Role.Admin) && isCompanyType(CompanyType.Carrier),
      },
      {
        name: 'invoices',
        label: 'drawer_menu.invoices',
        link: '/invoices',
        icon: <KNInvoiceIcon />,
      },
    ],
  },
  {
    sectionName: 'drawer_menu.admin',
    predicate: () => hasAccess(Role.Admin) || isCompanyType(CompanyType.Operator),
    sectionOptions: [
      {
        name: 'users',
        label: 'drawer_menu.users',
        link: '/users',
        icon: <KNUsersIcon />,
        predicate: () => hasAccess(Role.Admin) || isCompanyType(CompanyType.Operator),
      },
      {
        name: 'companies',
        label: 'drawer_menu.companies',
        link: '/companies',
        icon: <KNCompaniesIcon />,
        predicate: () => isCompanyType(CompanyType.Operator),
      },
      {
        name: 'carriers',
        label: 'drawer_menu.carriers',
        link: '/carriers',
        icon: <KNCarriersIcon />,
        predicate: () => isCompanyType(CompanyType.Operator),
      },
      {
        name: 'rejected-messages',
        label: 'drawer_menu.rejected_messages',
        link: '/rejected-messages',
        icon: <KNShipmentDescriptionIcon />,
        predicate: () => hasAccess(Role.Admin) && isCompanyType(CompanyType.Operator),
      },
    ],
  },
]

export const getMenuOptions = (): Section[] =>
  menuOptions()
    .filter((section) => !section.predicate || section.predicate())
    .map((section) => ({
      sectionName: section.sectionName,
      sectionShortName: section.sectionShortName,
      sectionOptions: section.sectionOptions.filter((option) => !option.predicate || option.predicate()),
    }))

export const userMenuOptions = (): Section[] => [
  {
    sectionName: 'drawer_menu.user',
    sectionOptions: [
      {
        name: 'help-and-info',
        label: 'drawer_menu.help_and_info',
        link: '/help-and-info',
        icon: <KNHelpAndInfoIcon />,
      },
      {
        name: 'companies',
        label: 'company_name',
        link: '',
        icon: <KNCompanyIcon />,
      },
      {
        name: 'user',
        label: 'username',
        link: '/profile',
        icon: <KNUserIcon />,
      }, {
        name: 'units',
        label: 'units',
        link: '',
        icon: <KNUnitsIcon />,
      }, {
        name: 'language',
        label: 'language',
        link: '',
        icon: <LanguageIcon />,
      }, {
        name: 'login_button',
        label: 'login_button',
        link: '/login',
        icon: <KNUserIcon />,
      },
    ],
  },
]

export const getUserMenuOptions = (): Section[] =>
  userMenuOptions()
    .filter((section) => !section.predicate || section.predicate())
    .map((section) => ({
      sectionName: section.sectionName,
      sectionShortName: section.sectionShortName,
      sectionOptions: section.sectionOptions.filter((option) => !option.predicate || option.predicate()),
    }))